import { render, staticRenderFns } from "./c_home_goods_list.vue?vue&type=template&id=83f676fa&scoped=true&"
import script from "./c_home_goods_list.vue?vue&type=script&lang=js&"
export * from "./c_home_goods_list.vue?vue&type=script&lang=js&"
import style0 from "./c_home_goods_list.vue?vue&type=style&index=0&id=83f676fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f676fa",
  null
  
)

export default component.exports